import { SingleDesignation } from "react-migration/domains/constraints/typings/applicationTypes/SingleDesignation";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { Banner } from "react-migration/domains/sites/components/Banner/Banner";
import { DNO_LOGOS } from "./constants";
import { DNO } from "./types";

interface SubstationAttributionProps {
  designation: SingleDesignation;
}

export function SubstationAttribution({ designation }: SubstationAttributionProps) {
  const { t, checkKey } = useTranslation();
  const translationKey = `power.power_substation_selection.dno.${designation?.source.authority.name}`;
  const hasTranslation = checkKey(translationKey);
  const dnoName = hasTranslation ? t(translationKey) : designation?.source.authority.name;
  const dnoLogo = DNO_LOGOS[designation.source.authority.name as DNO];

  if (!dnoLogo) {
    return null;
  }

  return (
    <div className="flex flex-col w-full p-4 gap-y-2">
      <div className="flex flex-row items-center justify-left w-full">
        <img
          src={DNO_LOGOS[designation.source.authority.name as DNO]}
          alt={`${dnoName} Logo`}
          title={dnoName}
          className="w-44"
        />
      </div>
      <Banner variant="info" showIcon message={`This information is sourced from ${dnoName}`} />
    </div>
  );
}
